import React from "react";
import IpCes2003 from "@/app/Components/CES/IpCes2003";
import Layout from "./ResearchGoal/Layout";
import Head from "next/head";
import TempCes2004 from "@/app/Components/CES/TempCES2024";

const ces2025Page = () => {
  return (
    <div>
      <Head>
        <title>CES Tech2025</title>
        <link
          rel="shortcut icon"
          href="/ipimages/enterprise/images/ufoant.ico"
        />
        <link
          rel="icon"
          type="image/ico"
          href="/ipimages/enterprise/images/ufoant.ico"
        />
        <link
          rel="apple-touch-icon"
          href="/ipimages/enterprise/images/ufoant.ico"
        />
        <meta
          content="The major trends to follow include Sustainability, smart home solutions, AI advancements, future mobility, cybersecurity, beauty tech, and digital healthcare"
          name="description"
        />
        <meta content="CES Tech2025" property="og:title" />
        <meta
          content="The major trends to follow include Sustainability, smart home solutions, AI advancements, future mobility, cybersecurity, beauty tech, and digital healthcare"
          property="og:description"
        />
        <meta
          content="CES Tech2025, When is CES 2025, CES Trade show las vegas, CES 2024 las vegas, 2025 CES,  
                    CES 2025, CES 2025 Dates, CES Innovation, CES Vegas, CES Tech Date, CES Venue"
          property="og:keywords"
        />
        <meta
          content="https://www.ideapoke.com/ipimages/enterprise/images/Ideapoke.jpg"
          property="og:image"
        />
        <meta content="CES Tech2025" property="twitter:title" />
        <meta
          content="The major trends to follow include Sustainability, smart home solutions, AI advancements, future mobility, cybersecurity, beauty tech, and digital healthcare"
          property="twitter:description"
        />
        <meta
          content="https://www.ideapoke.com/ipimages/enterprise/images/Ideapoke.jpg"
          property="twitter:image"
        />
        <meta
          content="CES Tech2025, When is CES 2025, CES Trade show las vegas, CES 2024 las vegas, 2025 CES,  
                    CES 2025, CES 2025 Dates, CES Innovation, CES Vegas, CES Tech Date, CES Venue"
          property="og:keywords"
        />

        <meta property="og:type" content="website" />
        <meta content="summary_large_image" name="twitter:card" />
        <meta content="width=device-width, initial-scale=1" name="viewport" />
      </Head>
      <Layout>
        <TempCes2004></TempCes2004>
      </Layout>
    </div>
  );
};

export default ces2025Page;
